'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp;

var _reactRedux = require('react-redux');

var _wish_list = require('redux/actions/wish_list');

var _LocalStorageProxy = require('ibonus/LocalStorageProxy');

var _LocalStorageProxy2 = _interopRequireDefault(_LocalStorageProxy);

var _modal = require('redux/actions/modal');

var _helpers = require('helpers');

var _reduxAsyncConnect = require('redux-async-connect');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    WishList: {
        displayName: 'WishList'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/containers/WishList/WishList.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var WishList = _wrapComponent('WishList')((_dec = (0, _reduxAsyncConnect.asyncConnect)([{
    promise: function promise(_ref) {
        var _ref$store = _ref.store,
            dispatch = _ref$store.dispatch,
            getState = _ref$store.getState;

        var products = getState().wishList.wishProducts;
        if (products) {
            return dispatch((0, _extends3.default)({}, (0, _wish_list.getActualPricesWishList)(products)));
        }
    }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
    return {
        setting: state.setting,
        wishProducts: state.wishList.wishProducts,
        lang: state.lang,
        currency: state.currency
    };
}, { delFromWishList: _wish_list.delFromWishList, showModal: _modal.showModal, hide: _modal.hide, setWishList: _wish_list.setWishList }), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(WishList, _Component);

    function WishList(props) {
        (0, _classCallCheck3.default)(this, WishList);

        var _this = (0, _possibleConstructorReturn3.default)(this, (WishList.__proto__ || (0, _getPrototypeOf2.default)(WishList)).call(this, props));

        _this.onDelete = function (id) {
            var lang = _this.props.lang;


            var modalContent = _react3.default.createElement(
                'div',
                { className: 'row no-margin' },
                _react3.default.createElement(
                    'div',
                    { className: 'col-xs-12' },
                    lang['store.wish_list.confirm_removal']
                )
            );

            _this.props.showModal({
                title: lang['store.wish_list.remove'],
                content: modalContent,
                titleSuccess: lang['store.common.yes'],
                titleClose: lang['store.common.no'],
                onSuccess: function onSuccess() {
                    _this.props.delFromWishList(id);
                    setTimeout(_this.props.setWishList(_LocalStorageProxy2.default.getItem('wishlist.common')), 50000);
                },
                modalType: 'del'
            });
        };

        return _this;
    }

    (0, _createClass3.default)(WishList, [{
        key: 'render',
        value: function render() {
            var View = _helpers.ThemeHelper.getViewForContainer('WishList');
            var orderInOneClick = this.props.setting;
            return _react3.default.createElement(View, {
                products: this.props.wishProducts,
                onDelete: this.onDelete,
                orderInOneClick: orderInOneClick,
                lang: this.props.lang,
                currency: this.props.currency
            });
        }
    }]);
    return WishList;
}(_react2.Component), _class2.propTypes = {
    wishProducts: _react2.PropTypes.array,
    lang: _react2.PropTypes.object,
    currency: _react2.PropTypes.object
}, _temp)) || _class) || _class));

exports.default = WishList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/WishList/WishList.jsx
// module id = 1853
// module chunks = 0